<template>
  <li>
    <h3>{{ fullName }}</h3>
    <h4>{{ age }} years old</h4>
    <div>
      <base-badge
        v-for="achievement in achievements"
        :key="achievement"
        :type="achievement"
        :title="achievement"
      ></base-badge>
    </div>
    <div>
      <div class="actions">
        <base-button link mode="outline" :to="skippersContactLink"
          >Contact</base-button
        >
        <base-button link :to="skippersDetailsLink">View Details</base-button>
      </div>
    </div>
  </li>
</template>

<style scoped>
li {
  margin: 1rem 0;
  border: 1px solid #424242;
  border-radius: 12px;
  padding: 1rem;
  list-style-type: none;
}

h3 {
  font-size: 1.5rem;
}

h3,
h4 {
  margin: 0.5rem 0;
}

div {
  margin: 0.5rem 0;
}

.actions {
  display: flex;
  justify-content: flex-end;
}
</style>

<script>
export default {
  props: ['id', 'firstName', 'lastName', 'age', 'achievements'],

  computed: {
    fullName() {
      return this.firstName + ' ' + this.lastName;
    },
    skippersContactLink() {
      return this.$route.path + '/' + this.id + '/contact'; //coaches/c1/contact
    },
    skippersDetailsLink() {
      return this.$route.path + '/' + this.id; // /coches/c1
    }
  }
};
</script>
